module.exports = __webpack_public_path__ + "img/18.344433f1.gif";